<template lang="pug">
NidCommentPage(
  :nid="nid"
  :language="commentLanguage"
)
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed } from "vue";

import { getStringParam, getStringQueryParameter } from "~/routing/routes";

import NidCommentPage from "~/components/NidCommentPage.vue";

const route = useRoute();
const i18n = useI18n();
const locale = i18n.locale;

const nid = computed<number>(
  () => parseInt(getStringParam(route, "nid") || "0") || 0,
);

const commentLanguage = computed<string>(
  () => getStringQueryParameter(route, "language") || locale.value,
);

/*
 * According to the recommendations at
 * https://developers.google.com/search/docs/specialty/international/managing-multi-regional-sites#make-sure-the-page-language-is-obvious
 * we should not allow pages with mixed-language content to be indexed.
 */
useRobotsRule(computed(() => commentLanguage.value === locale.value));
</script>
